import React from 'react';
import { PageHeader, NextMove, useTitle } from '../components/Layout';
import { useVisit } from '../progress';
import { profile, highlights, skills, education } from '../data';

export default function Opening() {
  useTitle('Opening');
  useVisit('opening');

  return (
    <div className="page">
      <PageHeader index="01" eyebrow="Opening" title="Every good game starts with the fundamentals.">
        Who I am, the strengths I bring to the board, and the preparation behind them.
      </PageHeader>

      <section className="about">
        <img src={profile.photo} alt="Portrait of Rohan Rout" className="about-photo" width="240" height="288" />
        <div className="about-copy">
          <h2 className="section-title">{profile.name}</h2>
          <p className="about-role">
            {profile.role} · {profile.focus}
          </p>
          <p>{profile.bio}</p>
          <p>{profile.intro}</p>
        </div>
      </section>

      <section className="block">
        <div className="block-head">
          <h2 className="section-title">Material advantage</h2>
          <p className="muted">The numbers I bring to the table.</p>
        </div>
        <div className="stats">
          {highlights.map((h) => (
            <div key={h.label} className="stat">
              <span className="stat-value">{h.value}</span>
              <span className="stat-label">{h.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="block">
        <div className="block-head">
          <h2 className="section-title">Repertoire</h2>
          <p className="muted">The lines I know well.</p>
        </div>
        <div className="repertoire">
          {skills.map((s) => (
            <div key={s.group} className="repertoire-group">
              <h3 className="repertoire-title">{s.group}</h3>
              <ul className="chips">
                {s.items.map((item) => (
                  <li key={item} className="chip">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="block">
        <div className="block-head">
          <h2 className="section-title">Preparation</h2>
          <p className="muted">Where I studied the theory.</p>
        </div>
        <div className="edu-list">
          {education.map((e) => (
            <article key={e.school} className="card edu">
              <div className="row-between">
                <div>
                  <h3 className="card-title">{e.degree}</h3>
                  <p className="card-sub">{e.school}</p>
                </div>
                <p className="meta">
                  {e.period}
                  <br />
                  {e.location}
                </p>
              </div>
              <ul className="bullets">
                {e.highlights.map((h) => (
                  <li key={h}>{h}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <NextMove current="/opening" />
    </div>
  );
}
